module.exports = __webpack_public_path__ + "./img/gif.c56d9564bc3670e23c0811d9b19226bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/gif.png
// module id = ./src/containers/Briefcase/entry/icons/gif.png
// module chunks = 0